import {
	AliasAuthenticationMessageOperationOutputDto,
	AliasAuthenticationTypeOperationOutputDto,
	ClickToCallAgentClosedOutputDto,
	ClickToCallAgentOpenOutputDto,
	ClickToCallAllInternationalDialingPhoneCodesOutputDto,
	ClickToCallIsOpenOutputDto,
	ClickToCallStatusOutputDto,
	ContextOutputDto,
	GetDocumentsReferenceOutputDto,
	PromoCodeDetailOutputDto,
	RetrieveAccountsOutputDto,
	RetrieveCountriesOutputDto,
	SubscriptionIntegratedSolutionOutputDto,
	SubscriptionMaintenanceContabOutputDto,
} from '@api/izibizi-xp';

export interface ServiceError {
	code: string;
	message: string;
}

export interface ServicesState {
	aliasAuthenticationMessage?: AliasAuthenticationMessageOperationOutputDto;
	aliasAuthenticationType?: AliasAuthenticationTypeOperationOutputDto;
	clickToCallAgentClosed?: ClickToCallAgentClosedOutputDto;
	clickToCallAgentOpen?: ClickToCallAgentOpenOutputDto;
	clickToCallAllInternationalDialingPhoneCodes?: ClickToCallAllInternationalDialingPhoneCodesOutputDto;
	clickToCallIsOpen?: ClickToCallIsOpenOutputDto;
	clickToCallStatus?: ClickToCallStatusOutputDto;
	error?: ServiceError;
	retrieveAccounts?: RetrieveAccountsOutputDto;
	retrieveContext?: ContextOutputDto;
	retrieveSoftwareDocumentReference?: GetDocumentsReferenceOutputDto;
	retrieveBankDocumentReference?: GetDocumentsReferenceOutputDto;
	retrievePromoCodeDetail?: PromoCodeDetailOutputDto;
	retrieveCountries?: RetrieveCountriesOutputDto;
	subscriptionMaintenance?: SubscriptionMaintenanceContabOutputDto;
	subscriptionIntegratedSolution?: SubscriptionIntegratedSolutionOutputDto;
	retrieveBankInsuranceDocumentReference?: GetDocumentsReferenceOutputDto;
	retrieveBankInsurancePersonalDocumentReference?: GetDocumentsReferenceOutputDto;
}

export const ServicesActionTypes = {
	saveSuccessServiceResponse: '@@Services/saveSuccessServiceResponse',
	saveErrorServiceResponse: '@@Services/saveErrorServiceResponse',
};
